import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"height":"500px"} }

import { ref, onMounted } from 'vue';
import * as IDETextEditor from '@/components/IDE/IDETextEditor.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'MonacoEditorTester',
  setup(__props) {


const editorContent = ref("-");

const texts = [
	"if (false) {console.log(`a`);}",
	"if (false) {console.log(`ah`);}",
	"if (false) {console.log(`aho`);}",
	"if (false) {console.log(`ahoj`);}",
	"if (false) {console.log(`jedna`);}",
	"if (false) {console.log(`jedna\ndva`);}",
	"if (false) {console.log(`jedna\ndva\ntri`);}",
	"if (false) {console.log(`jedna\ntri`);}",
	"if (false) {console.log(`jedna`);}",
	"if (false) {console.log(`ahoj\nlidi\njak se mate`);}",
	"if (false) {console.log(`nevim\nasi\ndobre`);}",
	"if (false) {console.log(`asi`);}",
	"if (false) {console.log(`aaaa\nbbb\ncccc\ndddd\neeee\nffff\n`);}",
	"if (false) {console.log(`aaaa\ncccc\ndddd\nffff\n`);}",
	"if (false) {console.log(`aaaa\nbbb\ncccc\ndddd\neeee\nffff\n`);}",
	"if (false) {console.log(`aaaa\nbbb\ncccc\nxxxx\ndddd\neeee\nffff\n`);}",
	"end",
];
let currentText = ref(-1);
function next() {
	currentText.value++;
	if (currentText.value >= texts.length) {
		currentText.value = 0;
	}
	editorContent.value = texts[currentText.value];
}

onMounted(() => {
	let n = 1;
	if (0) {
		setInterval(() => {
			++n;
			editorContent.value += `\n${n}`;
		}, 1000);
	}
});

function megaContent() {
	let text = "if(true){};".repeat(10) + "\n";
	text = text.repeat(100000);
	alert(text.length);
	editorContent.value = text;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (next()))
    }, "#" + _toDisplayString(_unref(currentText)) + " Next content", 1),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (megaContent()))
    }, "Mega content"),
    _createVNode(IDETextEditor.default, {
      content: editorContent.value,
      modelLanguage: "javascript"
    }, null, 8, ["content"])
  ]))
}
}

})